<script setup lang='ts'>
import type { SCORE } from '@/shared/constants'

const props = withDefaults(defineProps<{
  score?: keyof typeof SCORE
}>(), {
  score: '2',
})
</script>

<template>
  <div class="score flex items-center justify-center select-none pointer-events-none">
    <div class="item">
      {{ props.score }}分
    </div>
  </div>
</template>

<style lang='scss' scoped>
@import url("@/assets/styles/score.scss");
</style>
